import type * as React from 'react';
import { post } from '@Domain/Api';
import type { FacilityPayload } from '@Application/Facilities/Facilities/Actions/facilitiesFetched';
import facilityCreated, {
	type FacilityCreatedAction,
} from '@Application/Facilities/Facilities/Actions/facilityCreated';
import facilityCreationFailed, {
	type FacilityCreationFailedAction,
} from '@Application/Facilities/Facilities/Actions/facilityCreationFailed';
import type CreateFacility from '@Application/Facilities/Facilities/Commands/CreateFacility';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = FacilityCreatedAction | FacilityCreationFailedAction;

export default (command: CreateFacility) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<FacilityPayload>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/facilities`,
				command.toJSON(),
			);

			const action = facilityCreated(payload, command.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = facilityCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
